import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, getResetByTag } from '../../../../../styles';
import StyledModalHeaderTitle from './modal.header.title.styles';
import StyledModalHeaderChildren from './modal.header.children.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("color:", colors.coolGray_900, ";display:flex;justify-content:space-between;padding:", rem(14, 0), ";", StyledModalHeaderTitle, "{flex-direction:column;}", StyledModalHeaderChildren, "{display:flex;flex:auto;margin-right:", rem(32), ";position:relative;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var hasTitleStyles = function hasTitleStyles(_ref) {
  var title = _ref.title;
  if (title) {
    return /*#__PURE__*/css(StyledModalHeaderChildren, "{justify-content:flex-end;}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasTitleStyles;"));
  } else {
    return /*#__PURE__*/css(StyledModalHeaderChildren, "{justify-content:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasTitleStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledModalHeaderInner = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1gewtn20"
} : {
  target: "e1gewtn20",
  label: "StyledModalHeaderInner"
})(resetStyles, hasTitleStyles, defaultStyles);
export default StyledModalHeaderInner;